import React, { FC, useMemo, useRef, useState, useEffect } from 'react';

import { Switch } from '@chakra-ui/react';
import { Center, Flex, Text } from '@chakra-ui/layout';

import { useQuery } from 'react-query';
import { fetchAllPaginatedSKU } from 'api/sku';

import {
  EditSkuModal,
  EditSkuModalRef,
} from 'components/modules/EditSkuModall';
import { DataTable } from 'components/modules/DataTable';

import { SkuViewProps } from './Sku.props';
import { buildSkuCasesColumns } from './skuCasesColumns';

export const CasesTable: FC<SkuViewProps> = (props) => {
  const [page, setPage] = useState<number>(1);

  const { active, setActive, search } = props;

  const editSkuModalRef = useRef<EditSkuModalRef>(null);

  const columns = useMemo(() => buildSkuCasesColumns(), []);

  const queryKey = [`fetch-all-sku-case`, page, active, search];

  const queryFn = () =>
    fetchAllPaginatedSKU('case', {
      page,
      limit: 10,
      activeOnly: active,
      search: search || undefined,
    });

  const options = {
    keepPreviousData: true,
  };

  const { data, isFetching, isLoading } = useQuery(queryKey, queryFn, options);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const cases = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  return (
    <>
      <Flex my="10px" align="center" gap="10px">
        <Text>Show Active cases only</Text>
        <Switch
          colorScheme="primary"
          isChecked={active}
          onChange={(e) => setActive(e.target.checked)}
        />
      </Flex>
      <DataTable
        minW="420px"
        data={cases}
        columns={columns}
        isLoading={isLoading || isFetching}
        pagination={pagination}
        onRowClick={(sku) => {
          editSkuModalRef?.current?.onOpen?.(sku);
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Cases available</Text>
          </Center>
        )}
      />
      <EditSkuModal ref={editSkuModalRef} type={'case'} />
    </>
  );
};
